(function () {
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      drawer.classList.add('active', 'is-open');
      document.body.classList.add('overflow-hidden');
      return true;
    }

    var notif = document.querySelector('cart-notification');
    if (notif && typeof notif.open === 'function') {
      notif.open();
      return true;
    }

    var icon = document.querySelector('#cart-icon-bubble, .header__icon--cart, cart-drawer-button, [href="/cart"]');
    if (icon) {
      icon.click();
      return true;
    }
    return false;
  }

  function setLoading(btn, on) {
    if (!btn) return;
    var spinner = btn.querySelector('.loading-overlay__spinner');
    if (on) {
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function setAdded(btn) {
    if (!btn) return;
    setLoading(btn, false);
    btn.classList.add('is-added');

    var addLabel = btn.querySelector('.btn-label-add');
    var addedLabel = btn.querySelector('.btn-label-added');
    if (addLabel) addLabel.classList.add('hidden');
    if (addedLabel) addedLabel.classList.remove('hidden');

    setTimeout(function () {
      btn.classList.remove('is-added');
      if (addLabel) addLabel.classList.remove('hidden');
      if (addedLabel) addedLabel.classList.add('hidden');
    }, 1600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    var btn = form.querySelector('.quick-add__submit');
    setLoading(btn, true);
  }, true);

  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('.quick-add__submit.loading').forEach(setAdded);
    setTimeout(openCartDrawer, 120);
  });

  document.addEventListener('cart-update', function () {
    setTimeout(openCartDrawer, 120);
  });

  var _fetch = window.fetch;
  window.fetch = async function () {
    var res = await _fetch.apply(this, arguments);
    try {
      var url = (arguments[0] && arguments[0].url) ? arguments[0].url : String(arguments[0] || '');
      if (url.indexOf('/cart/add') !== -1 && res.ok) {
        setTimeout(function () {
          document.querySelectorAll('.quick-add__submit.loading').forEach(setAdded);
          openCartDrawer();
        }, 150);
      }
    } catch (err) {}
    return res;
  };
})();